// extracted by mini-css-extract-plugin
export default {"screen":"style_screen__0CIGH","calendar":"style_calendar__TNSyo","schedule":"style_schedule__lXEbS","loading":"style_loading__77iV0"};